import { render, staticRenderFns } from "./informallga.vue?vue&type=template&id=3da90daa&"
import script from "./informallga.vue?vue&type=script&lang=js&"
export * from "./informallga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports